import { render, staticRenderFns } from "./AuthorLabels.vue?vue&type=template&id=e82fcb5a&"
import script from "./AuthorLabels.vue?vue&type=script&lang=js&"
export * from "./AuthorLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports